import dateFnDifferenceInMilliseconds from 'date-fns/differenceInMilliseconds'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

const getMillisecondsDiff = (
  timeOneProp: dateParamType,
  timeTwoProp: dateParamType,
  absolute = true,
): number => {
  const time1 = toDate(timeOneProp)
  const time2 = toDate(timeTwoProp)

  const difference = dateFnDifferenceInMilliseconds(time2, time1)

  return absolute ? Math.abs(difference) : difference
}

export default getMillisecondsDiff
